"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pako_1 = require("pako");
function decodeAndDecompress(encodedString) {
    // Decode the base64 string back into a byte array
    const decodedByteArray = new Uint8Array(atob(encodedString)
        .split('')
        .map((char) => char.charCodeAt(0)));
    // Decompress the byte array using pako
    const decompressedString = pako_1.inflate(decodedByteArray, { to: 'string' });
    return JSON.parse(decompressedString);
}
exports.default = decodeAndDecompress;
//# sourceMappingURL=decompress.js.map